import React from 'react'
import { Form, Button, Input } from 'semantic-ui-react'
import { FormValidation } from '../components'
import { fields } from '../../common/lib/redux-fields'
import validate from '../../common/auth/validations'

const submitForm = async (e, { fields, submit, signIn }) => {
  e.preventDefault()
  const values = fields.$values()
  submit(values, signIn)
}

// eslint-disable-next-line
let SignInForm = ({ fields, signIn, submit, errorMessage }) => (
  <Form onSubmit={(e) => submitForm(e, { fields, submit, signIn })} size="huge">
    {errorMessage}
    <Form.Input
      {...fields.email}
      label="Email"
      placeholder="Váš email"
      type="email"
      required
    />
    <Form.Input
      {...fields.password}
      label="Heslo"
      placeholder="Vaše heslo"
      type="password"
      className="password"
      required
    />
    <div className="actions">
      <Button type="submit">
        Přihlásit se
      </Button>
    </div>
  </Form>
)

SignInForm.defaultProps = {
  submitting: false,
  submitSuccessfull: false,
}

SignInForm.propTypes = {
  fields: React.PropTypes.object,
  signIn: React.PropTypes.func.isRequired,
  errorMessage: React.PropTypes.any,
  submit: React.PropTypes.func.isRequired,
  submitting: React.PropTypes.bool,
  submitSuccessfull: React.PropTypes.bool,
}

SignInForm = fields(SignInForm, {
  path: 'SignInForm',
  fields: [
    'email',
    'password',
  ],
  getInitialState: () => ({}),
})

SignInForm = FormValidation(SignInForm, () => ({ submissionValidation: validate }))

export default SignInForm



// WEBPACK FOOTER //
// ./src/browser/forms/SignIn.js